"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "user",
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_415",
  "data-name": "Groupe 415",
  transform: "translate(0)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2109",
  "data-name": "Trac\xE9 2109",
  d: "M10.171,7.7a5.935,5.935,0,0,0-2.264-1.42,3.445,3.445,0,1,0-3.9,0A5.968,5.968,0,0,0,0,11.916H.931a5.027,5.027,0,0,1,10.054,0h.931A5.919,5.919,0,0,0,10.171,7.7ZM5.958,5.958A2.514,2.514,0,1,1,8.472,3.445,2.516,2.516,0,0,1,5.958,5.958Z",
  transform: "translate(0)",
  fill: "#23bacf",
  stroke: "#23bacf",
  strokeWidth: "0.5"
})));
let viewBox = '0 0 12.416 12.416';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'AccountIcon', viewBox);
